import { render, staticRenderFns } from "./NotreDemarche.vue?vue&type=template&id=2a955d2a&scoped=true"
import script from "./NotreDemarche.vue?vue&type=script&lang=js"
export * from "./NotreDemarche.vue?vue&type=script&lang=js"
import style0 from "./NotreDemarche.vue?vue&type=style&index=0&id=2a955d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a955d2a",
  null
  
)

export default component.exports